import ApiClient from '@/api/api-client'

export default function() {
    return {
        getCampaign: function() {
            return ApiClient.get('/campaign')
        },

        clearCampaign: function() {
            return ApiClient.get('/campaign/clear')
        }
    }
}
